export default {
  setRoom (context, payload) {
    context.commit('roomData', payload)
    context.commit('roomIdData', payload.Id)
  },

  setSchichtOption (context, payload) {
    context.commit('setSchichtData', payload)
  },
}
